let videoUrl = {
  video_wjy_1: '20230000001310001018:20230000001110001001', // 1) 入园监控（高清）
  video_wjy_2: '20230000001310001016:20230000001110001001', // 园区入场通道
  video_wjy_3: '20230000001310001020:20230000001110001001', // 3）楼顶全景
  video_wjy_4: '20230000001310001006:20230000001110001001', // 4) 2道50吨后
  video_wjy_5: '20230000001310001002:20230000001110001001', // 4) 货场监控-叉路口1 高清
  video_wjy_6: '20230000001310001007:20230000001110001001',
  video_wjy_7: '20230000001310001009:20230000001110002001',
  video_wjy_8: '20230000001310001004:20230000001110001001',
  // video_wjy_8: '20230000001310002008:20230000001110002001',
  video_dy_1: '20230000001310000001:20230000001110000001',
  video_dy_2: '20230000001310000002:20230000001110000001',
  video_dy_3: '20230000001310000002:20230000001110000001',
  video_dy_4: '20230000001310000006:20230000001110000001',//出口监管区
  video_dy_5: '20230000001310000002:20230000001110000001',//国门大桥
  video_dy_6: '20230000001310000003:20230000001110000001',
  video_dy_7: '20230000001310000009:20230000001110000001',
  video_dy_8: '20230000001310000002:20230000001110000001',
  video_dy_9: '20230000001310000003:20230000001110000001',//河口北山国际货场南卡口
  video_dy_10:'20230000001310000008:20230000001110000001',//进口监管区
  video_dy_11:'20230000001310000005:20230000001110000001',//北卡口入口通道
  video_dy_12:'20230000001310000001:20230000001110000001',//河口边民互市全景
  video_dy_13:'20230000001310000015:20230000001110000001',//边民互市交易大棚
  video_dy_14:'20230000001310000011:20230000001110000001',//一般贸易全景
  video_dy_15:'20230000001310000007:20230000001110000001',//口岸国门中越大桥
  video_xy_1: '20230000001310002001:20230000001110002001',
  video_xy_2: '20230000001310002008:20230000001110002001',// 办公楼顶球机
  video_xy_3: '20230000001310002009:20230000001110002001',//货场全局监控
  video_xy_4: '20230000001310002022:20230000001110002001',//货仓作业监控
  video_xy_5: '20230000001310002013:20230000001110002001',//办公楼
  video_xy_6: '20230000001310002029:20230000001110002001',//灯塔球机北
  video_xy_7: '20230000001310006028:20230000001110006001',//祥云二期煤炭仓储大棚1号云台
  video_xy_8: '20230000001310006031:20230000001110006001',//祥云二期煤炭仓储大棚3号云台
  video_xy_9: '20230000001310006029:20230000001110006001',//祥云二期煤炭仓储大棚2号云台
  video_sd_1: '20230000001310003001:20230000001110003001',
  video_sd_2: '20230000001310003002:20230000001110003001',
  video_xg_1: '20230000001310004001:20230000001110004001',//南坡5
  // video_xg_2: '20230000001310004003:20230000001110004001',
  // video_xg_3: '20230000001310004004:20230000001110004001',
  video_xg_4: '20230000001310004013:20230000001110004001',
  video_xg_5: '20230000001310004017:20230000001110004001',
  video_xg_6: '20230000001310004020:20230000001110004001',
  video_xg_7: '20230000001310004025:20230000001110004001',
  video_xg_8: '20230000001310004026:20230000001110004001',
  video_zt_1: '20230000001310005001:20230000001110005001',
  video_zt_2: '20230000001310005011:20230000001110005001',
  video_zt_3: '20230000001310005005:20230000001110005001',
  video_zt_4: '20230000001310005007:20230000001110005001',
  video_zt_5: '20230000001310005009:20230000001110005001',
  // video_zt_1_mp4: '20230000001310002008:20230000001110002001',
}
export default videoUrl
